// extracted by mini-css-extract-plugin
export default {"statusTag":"src-pages-AuditTrail-Communication-Components-StatusTag-css-module__statusTag--TPkPF"};